import { Spinner } from "./ui/spinner";

interface LoadingSpinnerProps {
	/** Size variant */
	size?: "sm" | "md" | "lg";
	/** Optional message below the spinner */
	message?: string;
	/** Center in viewport (full-page style) */
	centered?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
	size = "md",
	message,
	centered = false,
}) => {
	return (
		<div
			className={
				centered
					? "flex min-h-screen flex-col items-center justify-center gap-3"
					: "flex flex-col items-center gap-3"
			}
		>
			<Spinner size={size} />
			{message && (
				<p className="text-(--color-muted-foreground) text-sm">{message}</p>
			)}
		</div>
	);
};

export default LoadingSpinner;
